// removed by extract-text-webpack-plugin
module.exports = {"Hat":"Hat__Hat--1OT8g","headerP":"Hat__headerP--1XPS2","akes":"Hat__akes--3f3lL","title":"Hat__title--39W9E"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Hat/Hat.css
// module id = 66
// module chunks = 0